import React from 'react'
import '../styles.scss'

const PrivacyPage = () => {
  window.scrollTo(0, 90)
  return (
    <div className="comming-soon">
      <h2>Privacy Policy</h2>
      <h6>comming soon</h6>
    </div>
  )
}

export default PrivacyPage
